import { CheckCircle2, Settings, X } from "lucide-react";
import NotificationEmptyState from "./NotificationEmptyState";
import NotificationRow from "./NotificationRow";

// The drawer's inbox pane: title with the unread pill, the mark-all bar, the
// rows (or the empty state), and the footer link out to the notifications page.
const NotificationList = ({
  notifications,
  unreadCount,
  isLoading,
  onViewAll,
  onRowClick,
  onMarkAllRead,
  onOpenSettings,
  onClose,
}) => (
  <>
    <div className="w-full px-6 py-4 flex items-center justify-between border-b-[1px] border-[#EEF0F9]">
      <div className="flex items-center gap-3">
        <span className="font-OpenSansSemiBold text-[18px] leading-[28px] capitalize text-[#1A2332]">
          Notifications
        </span>
        {unreadCount > 0 && (
          <span className="px-2 py-[2px] rounded-full bg-[#EAF3FF] font-InterBold text-[12px] leading-[18px] text-[#0065FD]">
            {unreadCount}
          </span>
        )}
      </div>
      <div className="flex items-center gap-4">
        <button
          type="button"
          aria-label="Notification settings"
          onClick={onOpenSettings}
          className="text-[#7C829A] hover:text-[#1A2332]"
        >
          <Settings size={20} />
        </button>
        <button type="button" aria-label="Close" onClick={onClose} className="text-[#868DA6] hover:text-[#1A2332]">
          <X size={18} />
        </button>
      </div>
    </div>

    {notifications.length > 0 && (
      <div className="w-full px-5 py-2 flex items-center bg-white border-b-[1px] border-[#E5E8F3]">
        <button
          type="button"
          onClick={onMarkAllRead}
          className="h-[32px] px-1 flex items-center justify-center gap-2 rounded-md text-[#0065FD]"
        >
          <CheckCircle2 size={16} />
          <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize">
            Mark all as read
          </span>
        </button>
      </div>
    )}

    <div className="w-full flex-1 bg-white overflow-y-auto">
      {isLoading ? null : notifications.length === 0 ? (
        <NotificationEmptyState />
      ) : (
        notifications.map((item) => <NotificationRow key={item.id} item={item} onClick={onRowClick} />)
      )}
    </div>

    {notifications.length > 0 && (
      <div className="w-full p-4 flex flex-col items-center border-t-[1px] border-[#EEF0F9]">
        <button
          type="button"
          onClick={onViewAll}
          className="h-[32px] px-1 flex items-center justify-center rounded-md font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize text-[#0065FD]"
        >
          View all notifications
        </button>
      </div>
    )}
  </>
);

export default NotificationList;
